import { rtdb } from './FirebaseConfig';
import { ref, update, onValue } from "firebase/database";

const createRTDBSource = () => {

	const max = 10
	let current = 0;

	const incAndCheck = () => {
		current++
		console.trace("Checking usage", current, max)
		return current >= max
	}

	const updateBulk = (dataSet) => {
		update(ref(rtdb), dataSet)
	}

	const updateSingle = (path, value) => {
		update(ref(rtdb, path), value)
	}

	const subscribeToPage = (path, handlePage)=>{
		if (current >= max) {
			console.log("hit max: skiping subscribing to page")
		}

		let unsubscribe
		unsubscribe = onValue(ref(rtdb, path), (data)=>{
			
			handlePage(data)

			if (incAndCheck()) {
				console.log("hit max: unsubscribing from page")
				unsubscribe()
			}
		})

		return unsubscribe
	}


	return Object.freeze({
		updateBulk,
		updateSingle,
		subscribeToPage
	})
}

export const rtdbSource = createRTDBSource()